import { commonServerInstance, downloadInstance } from '@/utilities/instances'
import { downloadFile } from './common'
import {
  ISupplementarySearchParams,
  SupplementaryTab
} from '@/pages/CABillingSupplementary/Comp/types'

// ── Upload APIs ──

export const uploadClaimPackages = async (formData: FormData) => {
  const response = await commonServerInstance.post(
    '/settlement/supplementary/claims',
    formData
  )
  return response.data.data
}

export const uploadTransshipmentFile = async (formData: FormData) => {
  const response = await commonServerInstance.post(
    '/settlement/supplementary/transshipments',
    formData
  )
  return response.data.data
}

export const uploadPickupFile = async (formData: FormData) => {
  const response = await commonServerInstance.post(
    '/settlement/supplementary/pickups',
    formData
  )
  return response.data.data
}

// ── Download template ──

export const downloadTemplate = async (
  type: 'Claim' | 'Transshipment' | 'Pickup'
) => {
  const response = await downloadInstance.post('/settlement/downloadtemplate', {
    type
  })
  return await downloadFile(response, 'template.xlsx')
}

// ── List APIs ──

export const fetchClaimList = async (params: ISupplementarySearchParams) => {
  const response = await commonServerInstance.get(
    '/settlement/supplementary/claims',
    { params }
  )
  return response.data.data
}

export const fetchTransshipmentList = async (
  params: ISupplementarySearchParams
) => {
  const response = await commonServerInstance.get(
    '/settlement/supplementary/transshipments',
    { params }
  )
  return response.data.data
}

export const fetchPickupList = async (params: ISupplementarySearchParams) => {
  const response = await commonServerInstance.get(
    '/settlement/supplementary/pickups',
    { params }
  )
  return response.data.data
}

const TAB_LIST_API: Record<
  SupplementaryTab,
  (params: ISupplementarySearchParams) => Promise<any>
> = {
  claim: fetchClaimList,
  transshipment: fetchTransshipmentList,
  pickup: fetchPickupList
}

export const fetchSupplementaryList = async (
  tab: SupplementaryTab,
  params: ISupplementarySearchParams
) => {
  return TAB_LIST_API[tab](params)
}
